import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import Team from './team'
import Collaborations from './collaborations'
import PrivacyPolicy from './Privacy_Policy'
import TermsAndConditions from './TnC_Page'
import DeleteAccount from './DeleteAccount'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/team" element={<Team />} />
        <Route path="/collaborations" element={<Collaborations />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
)